import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { llinkidDefaultBuildingBlocks } from './llinkidGenericConfigProps';

const LLINKID_CONTEXT: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  information: {
    single: 'Situering',
    plural: 'Situering',
  },

  buildingBlocks: llinkidDefaultBuildingBlocks,
  edit: [],
  showPlaceholder: true,
  readOnlyNode: true,

  isNotDraggable: true,
  isNotDeletable: true,
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default LLINKID_CONTEXT;
